export const PRODUCTS = [
  "load-balancer",
  "mesh-networking",
  "networking-for-kubernetes",
  "runtime-security",
  "networking-for-virtualization",
];
